import waitForLoad from "../utils/waitForLoad";
export var domain = 'js.hs-scripts.com';
var isHubspotWidgetDefined = function isHubspotWidgetDefined() {
  return window.HubSpotConversations && window.HubSpotConversations.widget;
};
var loadScript = function loadScript(hsId) {
  // Detect the provider is already loaded and return early
  if (window.HubSpotConversations) {
    return false;
  }
  (function loadHubSpotSDK(d, s, id) {
    // fetch customerchat.js
    var fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    var js = d.createElement(s);
    js.id = id;
    js.src = "https://".concat(domain, "/").concat(hsId, ".js");
    js.type = 'text/javascript';
    js.async = 1;
    js.defer = 1;
    if (fjs) {
      var _fjs$parentNode;
      (_fjs$parentNode = fjs.parentNode) === null || _fjs$parentNode === void 0 || _fjs$parentNode.insertBefore(js, fjs);
    } else {
      d.body.appendChild(js);
    }
  })(window.document, 'script', 'hs-script-loader');
  return true;
};
var load = function load(_ref) {
  var providerKey = _ref.providerKey,
    setState = _ref.setState,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  window.hsConversationsOnReady = [function () {
    isHubspotWidgetDefined() && window.HubSpotConversations.widget.load();
  }];
  var loaded = loadScript(providerKey);
  if (loaded) {
    beforeInit();
    waitForLoad(function () {
      return Boolean(isHubspotWidgetDefined() && window.HubSpotConversations.widget.status().loaded);
    },
    // Allow hubspot to complete loading before removing fake widget
    function () {
      isHubspotWidgetDefined() && window.HubSpotConversations.widget.open();
      setState('complete');
      onReady();
    });
  }
  return loaded;
};
var open = function open() {
  isHubspotWidgetDefined() && !window.HubSpotConversations.widget.status().loaded && window.HubSpotConversations.widget.load();
  return isHubspotWidgetDefined() && window.HubSpotConversations.widget.open();
}; // Open provider
var close = function close() {
  return isHubspotWidgetDefined() && window.HubSpotConversations.widget.close();
}; // Close provider

export default {
  load: load,
  open: open,
  close: close,
  domain: domain
};